import React, { useEffect, useState } from 'react';
import '../../css/nftDetailModal.css';
import close_btn from '../../assets/close.svg';
import axios from 'axios';
import Loading from '../Loading';
import filterBtn from '../../assets/filter-arrow.svg';
import checkImg from '../../assets/check.png';
import shareImg from '../../assets/share.png';
import aboutIcon from '../../assets/aboutIcon.png';
import toggleIcon from '../../assets/toggleIcon.png';
import nftAboutIcon from '../../assets/nftAboutMenu.png';
import {
	languageSetting,
	translatedText,
} from '../../recoil-states/language-state';
import { useRecoilValue } from 'recoil';
import { motion } from 'framer-motion';

const NftDetailModal = ({ id, text, name, setOpenDetailModal }) => {
	let detailData;
	const [nftData, setNftData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [openAbout, setOpenAbout] = useState(true);
	const [openDes, setOpenDes] = useState(true);
	const textData = useRecoilValue(translatedText);
	const nftDataLogo = textData.story.carousel_duman;
	const [nftDetailData, setNftDetailData] = useState(null);
	const localeLang = useRecoilValue(languageSetting);

	useEffect(() => {
		// getData();

		document.body.style.overflow = 'hidden';

		if (name === 'Tori' || name === '푸들') {
			setNftDetailData(nftDataLogo[1]);
		} else if (name === 'Andre' || name === '불독') {
			setNftDetailData(nftDataLogo[5]);
		} else if (name === 'Dove' || name === '도베르만') {
			setNftDetailData(nftDataLogo[3]);
		} else if (name === 'KM' || name === '진도') {
			setNftDetailData(nftDataLogo[4]);
		} else if (name === 'Collin' || name === '보더콜리') {
			setNftDetailData(nftDataLogo[2]);
		}
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);

	const goOpenSea = () => {
		window.open(
			`https://opensea.io/assets/ethereum/0x8db7af4c6420d6c9ad881d91259970a61143773b/${id}`
		);
	};

	const onCloseModal = e => {
		if (e.target.id === 'nft_gallery_modal') {
			setOpenDetailModal(false);
		}
	};

	return (
		<div
			className='nft_detail_modal'
			id='nft_gallery_modal'
			onClick={onCloseModal}>
			<motion.div
				className='nft_detail_modal_container'
				initial={{
					opacity: 0,
					scale: 0.75,
				}}
				animate={{
					opacity: 1,
					scale: 1,
					transition: {
						ease: 'easeOut',
						duration: 0.15,
					},
				}}
				exit={{
					opacity: 0,
					scale: 0.75,
					transition: {
						ease: 'easeIn',
						duration: 0.15,
					},
				}}>
				<div className='nft_box_container'>
					<div
						className='close_btn_svg'
						onClick={() => setOpenDetailModal(false)}
						style={{ cursor: 'pointer' }}>
						<img src={close_btn} />
					</div>
					<div className='nft_detail_image'>
						<img
							src={`${process.env.PUBLIC_URL}/assets/${text}/${id}.webp`}
							style={{ width: '100%', borderRadius: '10px' }}
						/>
					</div>
					<div className='konnect_text'>
						<h3>
							Konnect World
							<img src={checkImg} />
						</h3>
						<p>
							Owned by <span>Konnect</span>
							<img src={shareImg} />
						</p>
					</div>
					<div className='nft_detail_text_box'>
						<div className='text_box_left'>
							<h1>Konnect</h1>
							<h1>DUMAN PFP NFT</h1>
						</div>
						<div className='text_box_right'>
							<p>#{id}</p>
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openAbout ? '10px' : null }}
							onClick={() => setOpenAbout(!openAbout)}>
							<div className='nft_about_box_left'>
								<img src={aboutIcon} />
								<h1>About Konnect World (DUMAN)</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openAbout
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>

						<div
							className='nft_about_content'
							aria-expanded={!openAbout}>
							{localeLang === 'en' ? (
								<p>
									&nbsp;There are numerous animals evolved
									through big bang energy in the Konnect
									World. This evolution brought about several
									major changes to animals. The first change
									is personification of animals resulted in
									animals to be able to use tools and walk
									bipedally. The second change is sharp
									increase in intelligence. Among animals that
									have evolved, because DUMAN species, from
									which dogs evolved, lived closest to human
									knowledge and skills and become the
									domi-nant species in the konnectWorld.
									DUMANs always miss humans, so in order to
									travel to the another Earth and meet them
									again, they are constantly researching and
									wationg for the day of reunion.
								</p>
							) : (
								<p>
									Konnect World에는 빅뱅 에너지를 통해 진화한
									수많은 동물들이 살고 있다.이 진화는 동물에게
									몇가지 큰 변화를 가져다 주게 된다. 첫번째는
									의인화이며 이로 인해 동물들은 도구를
									사용하고 이족 보행을 하게 된다.두번째는
									엄청난 에너지를 받아 들이면서 지능이
									급격하게 상승하게 된다.그 중 개들이 진화한
									DUMAN종은 인간과 가장 가까이에 살며 인간을
									관찰하고 그들의 문명에 익숙하였기에 인간의
									지식과 기술을 이어 받고 더욱 발전 시켜
									Konnect World의 지배종이 된다. 이런 Duman은
									항상 인간을 그리워 하였으며 다른 차원의
									지구로 가서 인간을 다시 만나기 위해 끊임
									없는 연구를 하며 다시 만날 날을 기다린다.
								</p>
							)}
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openDes ? '10px' : null }}
							onClick={() => setOpenDes(!openDes)}>
							<div className='nft_about_box_left'>
								<img src={nftAboutIcon} />
								<h1>Description</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openDes
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>
						{nftDetailData !== null ? (
							<div
								className='nft_about_content_bottom'
								aria-expanded={!openDes}>
								<p>KONNECT PFP NFT</p>
								<h1>Package Information</h1>
								<div className='duman_info'>
									<div className='duman_info_top'>
										<div className='duman_info_img'>
											<img
												src={require(`../../assets/${nftDetailData.img}`)}
											/>
										</div>
										<div className='duman_info_content'>
											<h3>
												{nftDetailData.title}{' '}
												{nftDetailData.subTitle}
											</h3>
											<p>{nftDetailData.content}</p>
										</div>
									</div>
									<div className='duman_info_bottom'>
										<div className='duman_info_bottom_top'>
											<div>
												<p>
													{textData.story['Breed']}:{' '}
													{nftDetailData.profile.type}
												</p>
											</div>
											<div>
												<p>
													{
														textData.story[
														'Occupation'
														]
													}
													:{' '}
													{nftDetailData.profile.job}
												</p>
											</div>
										</div>
										<div className='duman_info_bottom_bottom'>
											<div>
												<p>
													{textData.story['Style']}:{' '}
													{
														nftDetailData.profile
															.style
													}
												</p>
											</div>
											<div>
												<p>
													{
														textData.story[
														'Characteristics'
														]
													}
													:{' '}
													{
														nftDetailData.profile
															.pesonality
													}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						) : null}
					</div>
					{/* <div className='opensea_btn'>
                                <button onClick={()=>{alert("준비중입니다")}}>OPENSEA에서 보기</button>
                            </div> */}
				</div>
			</motion.div>
		</div>
	);
};

export default NftDetailModal;
